import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

interface CartContextType {
  selectAnim: number[];
  setSelectAnim: React.Dispatch<React.SetStateAction<number[]>>; // updated to accept a function or an array
  myVideosAnim: number[];
  setMyVideosAnim: React.Dispatch<React.SetStateAction<number[]>>; // updated to accept a function or an array

  activeAnim: number;
  setActiveAnim: (value: number) => void;
  activeAnimIndex: number;
  setActiveAnimIndex: (value: number) => void;
  cartCount: number;
  setCartCount: (value: number) => void;
  incrementCartCount: (value: number) => void;
  decrementCartCount: (value: number) => void;
  isSystemNumber: number | undefined;
  setSystemNumber: (value: number) => void;
  isAnimationId: number | undefined;
  setAnimationId: (value: number) => void;
}

const CartContext = createContext<CartContextType | undefined>(undefined);

export const CartProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  // State for active animation
  const [activeAnim, setActiveAnim] = useState<number>(1); // Initially set to 1
  const [activeAnimIndex, setActiveAnimIndex] = useState<number>(0); // Initially set to 1
  // State for selectAnim with default value from local storage
  const [isSystemNumber, setSystemNumber] = useState<number | undefined>(
    undefined
  ); // No initial value
  const [isAnimationId, setAnimationId] = useState<number | undefined>(
    undefined
  ); // No initial value
  const [selectAnim, setSelectAnim] = useState<number[]>(() => {
    const stored = localStorage.getItem("selectAnim");
    return stored ? JSON.parse(stored) : [];
  });

  const [myVideosAnim, setMyVideosAnim] = useState<number[]>(() => {
    const stored = localStorage.getItem("myVideosAnim");
    return stored ? JSON.parse(stored) : [];
  });
  // const [selectAnim, setSelectAnim] = useState<number[]>([]);

  // const [cartCount, setCartCount] = useState(selectAnim.length);
  const [cartCount, setCartCount] = useState(() => {
    const stored = localStorage.getItem("cartCount");
    return stored ? parseInt(stored, 10) : 0;
  });

  useEffect(() => {
    localStorage.setItem("selectAnim", JSON.stringify(selectAnim));
  }, [selectAnim]);

  useEffect(() => {
    localStorage.setItem("myVideosAnim", JSON.stringify(myVideosAnim));
  }, [myVideosAnim]);

  useEffect(() => {
    localStorage.setItem("cartCount", cartCount.toString());
  }, [cartCount]);

  const incrementCartCount = () => {
    setCartCount((prevCount) => prevCount + 1);
  };
  const decrementCartCount = () => {
    setCartCount((prevCount) => prevCount - 1);
  };
  const contextValue: CartContextType = {
    selectAnim,
    setSelectAnim,
    myVideosAnim,
    setMyVideosAnim,
    activeAnim,
    setActiveAnim,
    activeAnimIndex,
    setActiveAnimIndex,
    cartCount,
    setCartCount,
    incrementCartCount,
    decrementCartCount,
    isSystemNumber,
    setSystemNumber,
    isAnimationId,
    setAnimationId,
  };
  return (
    <CartContext.Provider value={contextValue}>{children}</CartContext.Provider>
  );
};

export const useCart = (): CartContextType => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
};
